import React from 'react'
import { useNavigate } from 'react-router-dom'

import { BaseSafeFormView, BaseView } from '@/components/base'
import { StickyHeaderNavigation } from '@/components'
import { PortfolioCard } from '@/components/PortfolioCard'
import { AssetsList } from '@/components/AssetsList'
import { SelectDisplayCurrency } from '@/features/dashboard/components/CurrenciesList/components/SelectDisplayCurrency'
import { useUserStore } from '@/store'
import { useTranslation } from 'react-i18next'

export const PortfolioScreen: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const userDisplayCurrency = useUserStore(
    (state) => state.wallet?.displayCurrency,
  )

  const handleBackPress = () => {
    navigate('/dashboard')
  }

  return (
    <BaseSafeFormView
      style={{}}
      flex={1}
      bgColor="background.screen"
      className="h-full"
    >
      <StickyHeaderNavigation
        title={t('translation:portfolio.totalValue')}
        onBackPress={handleBackPress}
      />

      <BaseView gap={16} px={13} py={16}>
        <PortfolioCard key={userDisplayCurrency} />

        <AssetsList />

        <SelectDisplayCurrency />
      </BaseView>
    </BaseSafeFormView>
  )
}
